import { parseFormToBackend } from '@/modules/public/enquiry-form/misc/parsePayload.js';
import { identifyChatGptUser } from '@/services/chatgpt-pixel.js';
import {
  getDatesNoLongerAvailableConfig,
  getIsLimitExceededConfig,
} from '@/services/enquiry-sent-modal-configs';
import { getAllInteractionsPropertiesForEnquiry } from '@/services/interactions-tracker';
import { getCapturedUtmParams } from '@/services/utm-tracker';

const actions = {
  sendEnquiry({ state, commit, getters, dispatch }, options = {}) {
    console.log('sendEnquiry');
    commit('setLoading', { request: 'sendEnquiry', value: true });
    const formDataKeeper = App.es6.views.quick_estimate.form_data_keeper();
    const { email, fullName, phone } = state.form.userInfo;
    identifyChatGptUser({ email, fullName, phone });

    const payload = parseFormToBackend({
      form: state.form,
      tags: state.eventTypes,
      isWedding: getters.isWedding,
      l10n: state.l10n,
    });

    $.ajax({
      url: state.api.sendEnquiry,
      method: 'POST',
      dataType: 'json',
      data: {
        room_id: state.room.id,
        _token: state.api.token,
        'g-recaptcha-response': state.captcha.token,

        analytics_client_id: state.analyticsClientId,
        referrer: state.referrer,
        event_offer_name: state.room.eventOfferName,

        source: {
          name: 'room',
          ...getAllInteractionsPropertiesForEnquiry(state.room.id),
          ...getCapturedUtmParams(),
        },

        trackingParams: getters.authEventsTrackingParams('email_password'),

        ...payload,
        ...options?.additionalParams,
      },
      success(response) {
        if (response.rfp_id && response?.is_new_enquiry) {
          dispatch('trackGA4NewEnquiry', {
            userId: response.user_id,
            rfpId: response.rfp_id,
            enquiryId: response.enquiry_id,
            estimatedValue: response.estimated_value,
          });
        }

        if (response.rfp_id) {
          dispatch('trackGA4Enquiry', {
            userId: response.user_id,
            rfpId: response.rfp_id,
            enquiryId: response.enquiry_id,
            estimatedValue: response.estimated_value,
          });

          dispatch('trackEnquiryFormAction', {
            action: 'rfp-sent',
            label: response.rfp_id,
          });
        }

        formDataKeeper.setRawData({
          freeze: true,
          ...payload,
          enquiry_comment: state.form.messageAndCatering.message,
        });

        dispatch('betterUptimeEnquiryHeartbeat');

        if (options?.customSuccessHandler) {
          commit('setLoading', { request: 'sendEnquiry', value: false });
          options.customSuccessHandler(response);
        } else {
          if (response.instantRedirect && state.requestToBookPath && response.requestToBookUrl) {
            window.location = response.requestToBookUrl;
            return;
          }

          if (response.instantRedirect) {
            window.location = response.redirectUrl;
            return;
          }

          dispatch('enquirySentModal', response);
        }
      },
      error(response) {
        if (response.status === 403) {
          commit('enableCaptcha');
          commit('setCaptchaToken', null);
          Rollbar.debug('Captcha requested');

          window.CAPTCHA_CALLBACK = () => {
            dispatch('sendEnquiry', options);
            window.CAPTCHA_CALLBACK = null;
          };

          return;
        }
        dispatch('enquirySentModal', {
          redirectUrl: response.redirectUrl,
        });

        if (response.status !== 200 && response.status !== 0) {
          Rollbar.critical('Failed to send enquiry. Server Error');
        }
      },
      complete() {
        // We don't remove the loading, so the user sees the loading until he's redirected to the recommender page.
        // commit('setLoading', { request: 'sendEnquiry', value: false });
      },
    });

    Rollbar.info('Enquiry sent');
  },
  betterUptimeEnquiryHeartbeat() {
    try {
      window.navigator.sendBeacon('https://betteruptime.com/api/v1/heartbeat/QLt2EefG4KZrZjcPDfFL4kUW');
    } catch {
      // ignore
    }
  },
  enquirySentModal({ state, commit, dispatch }, enquiryResponse) {
    const { isLimitExceeded, isEmailRecognized, rfpsLimit, isRoomUnavailable, redirectUrl } = enquiryResponse;

    let config = null;
    if (isRoomUnavailable) {
      config = getDatesNoLongerAvailableConfig();
    } else if (isLimitExceeded) {
      config = getIsLimitExceededConfig(rfpsLimit);

      dispatch('trackGA4Interaction', {
        section: 'active_rfps_limit_exceeded_warning',
        element: 'warning_modal',
        interaction: 'visible',
      });
    } else if (isEmailRecognized) {
      commit('setIsEnquiryFormModalOpen', false);
      commit('setEnquirySentWelcomeBack', {
        email: state.form.userInfo.email,
        redirectUrl,
        lastEnquiry: {
          date: enquiryResponse.last_rfp_sent_at,
          url: enquiryResponse.last_rfp_url,
        },
      });

      return;
    } else {
      config = getDatesNoLongerAvailableConfig(); // we do not have anything better to show

      Rollbar.error('Enquiry sent without correct handling', enquiryResponse);
    }

    if (config !== null) {
      if (redirectUrl) {
        config.onClose = () => {
          window.location = redirectUrl;
        };
      } else {
        config.onClose = () => {
          window.location.reload();
        };
      }
    }

    commit('setEnquirySentModalConfig', config);
  },
  requestToBookFlow({ state, commit }) {
    commit('setLoading', { request: 'sendEnquiry', value: true });

    const payload = parseFormToBackend({
      form: state.form,
      tags: state.eventTypes,
    });

    App.es6.views.quick_estimate.form_data_keeper().setRawData({
      freeze: true,
      ...payload,
      analytics_client_id: state.analyticsClientId,
      referrer: state.referrer,
      event_offer_name: state.room.eventOfferName,
      source: {
        name: 'room',
        ...getAllInteractionsPropertiesForEnquiry(state.room.id),
        ...getCapturedUtmParams(),
      },
    });

    window.location = state.pages.requestToBookFlow;
  },
};

export default actions;
